import { SgvId, SgvJson } from '@eceos/arch';

export class IbsCbs {
  constructor(
    readonly id: string = SgvId.gen(),
    public cst: string = null,
    public cClassTrib: string = null,
    public pIbsUf: number = null,
    public pIbsMun: number = null,
    public pCbs: number = null,
    public bcValue: number = null,
    public vIbsUf: number = null,
    public vIbsMun: number = null,
    public vIbs: number = null,
    public vCbs: number = null
  ) {}

  isValid(): boolean {
    return this.cst != null;
  }

  toJson(): any {
    return SgvJson.to.simple(this);
  }

  static fromJson(json: any): IbsCbs {
    return json ? SgvJson.from.simple(json, IbsCbs) : null;
  }
}
